import { render, staticRenderFns } from "./addAccount.vue?vue&type=template&id=182dcbda&scoped=true"
import script from "./addAccount.vue?vue&type=script&lang=ts"
export * from "./addAccount.vue?vue&type=script&lang=ts"
import style0 from "./addAccount.vue?vue&type=style&index=0&id=182dcbda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182dcbda",
  null
  
)

export default component.exports